// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cf9b2cd8","884":"b059ce75"}[chunkId] + ".chunk.js";
};